import {
  Box,
  Container,
  Stack,
  Button,
  Heading,
  Text,
  Link,
} from "@chakra-ui/react";
import { Fragment } from "react";
import Navbar from "../components/Navbar";

export default function Landing() {
  return (
    <Box backgroundColor={"#EFE1CC80"}>
      <Navbar />
      <Container maxW={"7xl"}>
        <Stack
          as={Box}
          textAlign={"center"}
          spacing={{ base: 8, md: 14 }}
          py={{ base: 20, md: 36 }}
        >
          <Heading
            fontWeight={600}
            fontSize={{ base: "2xl", sm: "4xl", md: "6xl" }}
            lineHeight={"110%"}
          >
            Welcome to Altru! <br />
            <Text as={"span"} color={"#5E856D"}>
              Promoting sustainability through generosity.
            </Text>
          </Heading>
          <Text color={"black"}>
            Altru is an online platform that decreases material waste by
            redirecting donors’ items to local donation centers.
          </Text>
          <Stack
            direction={"column"}
            spacing={3}
            align={"center"}
            alignSelf={"center"}
            position={"relative"}
          >
            <Link
              // as='button'
              href="/donate"
            >
              <Button
                colorScheme={"#5E856D"}
                bg={"#5E856D"}
                rounded={"full"}
                px={6}
              >
                Get Started
              </Button>
            </Link>
            {/* <Button variant={"link"} colorScheme={"blue"} size={"sm"}>
              Learn more
            </Button> */}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
